'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import useWebSocket from 'react-use-websocket';
import { useAuthStore } from '@/app/hooks/auth';

interface WebSocketContextType {
  unreadCount: number;
  resetUnreadCount: () => void;
}

const WebSocketContext = createContext<WebSocketContextType>({
  unreadCount: 0,
  resetUnreadCount: () => {},
});

export const WebSocketProvider = ({ children }: { children: React.ReactNode }) => {
  const [unreadCount, setUnreadCount] = useState<number>(0);

  // Usa as propriedades corretas da sua AuthState
  const { user, accessToken } = useAuthStore();

  // Conecta usando o accessToken e o host correto do ambiente
  const wsHost = process.env.NEXT_PUBLIC_WS_HOST;
  const socketUrl = user?.id && wsHost
    ? `${wsHost}/ws/notifications/${accessToken ? `?token=${accessToken}` : ''}`
    : null;

  const { lastJsonMessage } = useWebSocket(socketUrl, {
    share: true,
    shouldReconnect: () => true,
    reconnectInterval: 3000,
  });

  // Trata mensagens recebidas pelo canal global
  useEffect(() => {
    if (!lastJsonMessage) return;

    const payload: any = lastJsonMessage;

    if (payload?.type === 'new_message' || payload?.event === 'chat_message') {
      const senderId = payload?.data?.created_by_id ?? payload?.data?.created_by?.id;

      if (senderId && String(senderId) !== String(user?.id)) {
        setUnreadCount((prev) => prev + 1);
      }
    }
  }, [lastJsonMessage, user?.id]);

  const resetUnreadCount = () => setUnreadCount(0);

  return (
    <WebSocketContext.Provider value={{ unreadCount, resetUnreadCount }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useNotification = () => useContext(WebSocketContext);
